import _initializerDefineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty.js";
import _defineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _applyDecoratedDescriptor from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor.js";
import _initializerWarningHelper from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerWarningHelper.js";
var _class, _descriptor;
/* import __COLOCATED_TEMPLATE__ from './append-tags.hbs'; */
import Component from "@glimmer/component";
import { tracked } from "@glimmer/tracking";
import TEMPLATE from "./append-tags.hbs";
import { setComponentTemplate } from "@ember/component";
let AppendTags = (_class = class AppendTags extends Component {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "tags", _descriptor, this);
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "tags", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
})), _class);
export { AppendTags as default };
setComponentTemplate(TEMPLATE, AppendTags);